import SharedResourcesList from '@efdigital/ll-xceed-v2/components/coaching/shared-resources-list.gts';
import type { CoachingCoachCoacheesCoacheeResourcesModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/coachees/coachee/resources';
import type { TOC } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachCoacheesCoacheeResourcesSignature {
  Args: {
    model: CoachingCoachCoacheesCoacheeResourcesModel;
    controller: unknown;
  };
}

<template>
  {{pageTitle "Resources"}}

  <SharedResourcesList
    @items={{@model.items}}
    @partnership={{@model.defaultPartnership}}
    @role="coach"
  />
</template> satisfies TOC<CoachingCoachCoacheesCoacheeResourcesSignature>;
